import { render, staticRenderFns } from "./DisplayTime.vue?vue&type=template&id=631fd7e8&"
import script from "./DisplayTime.vue?vue&type=script&lang=js&"
export * from "./DisplayTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports